import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Image,
  Platform,
  ScrollView,
} from "react-native"
import Colors from "../constants/Colors"
import moment from "moment-jalaali"
import { Link } from "@react-navigation/native"
import { Ionicons } from "@expo/vector-icons"
import { useState } from "react"
import { useEffect } from "react"
import axios from "axios"
import Config from "../constants/Config"
import { useSelector } from "react-redux"

const AnalyseUserCard = (props) => {
  const { item, reload } = props

  const [color, setColor] = useState("#F2F2F2")

  const token = useSelector((store) => store.user.token)
  const capabilities = useSelector((store) => store.user.capabilities)

  const [dropDown, setDropDown] = useState(false)
  const [projectMonths, setProjectMonths] = useState([])

  const dropDownToggle = () => setDropDown((prev) => !prev)

  const submit = (value) => {
    console.log(value)

    axios
      .post(
        Config.aioUrl + "/project/set-kpi",
        { id: item.id, kpi: value },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        },
      )
      .then((res) => {
        alert(res.data.msg)
        reload(true)
      })

    dropDownToggle()
  }

  const colorHandler = () => {
    const stage = +item.stage_id
    const endDate = item.end_date

    const stage_paid_not_completed = props.isSiteDepartment
      ? 9
      : props.isGraphicDepartment
        ? 17
        : 24
    const stage_paid_and_completed = props.isSiteDepartment
      ? 10
      : props.isGraphicDepartment
        ? 18
        : 25
    const cancled = props.isSiteDepartment
      ? 29
      : props.isGraphicDepartment
        ? 28
        : 38

    // Add one for the current day
    const daysPassed = moment().diff(moment.unix(endDate), "days") + 1
    // Check is timestamp bigger than current timestamp
    const isFuture = moment.now() / 1000 < endDate

    // Project amount paid
    if (
      stage === stage_paid_not_completed ||
      stage === stage_paid_and_completed
    )
      return setColor("#4CAF50")

    // Canceled project
    if (stage === cancled) return setColor("#673AB7")

    // Not paid amount and less than 7 days left
    if (
      stage !== stage_paid_not_completed &&
      stage !== stage_paid_and_completed &&
      daysPassed <= 7 &&
      !isFuture
    )
      return setColor("#FF5722")

    // Not paid amount and more than 7 days left
    if (
      stage !== stage_paid_not_completed &&
      stage !== stage_paid_and_completed &&
      daysPassed > 7
    )
      return setColor("#D32F2F")

    // Another stage
    setColor("#F2F2F2")
  }

  useEffect(() => {
    colorHandler()
  }, [item])

  useEffect(() => {
    const endMoment = moment().add(3, "jMonth").endOf("jMonth")
    const startMoment = moment("1401-12-01", "jYYYY-jMM-jDD")

    const diffInJMonths =
      (endMoment.jYear() - startMoment.jYear()) * 12 +
      (endMoment.jMonth() - startMoment.jMonth())

    const months = []

    for (let index = 0; index <= diffInJMonths; index++) {
      const currentMonth = moment(endMoment).subtract(index, "jMonth")

      const monthOBJ = {
        name: currentMonth.format("jMMMM jYYYY"),
        unix: currentMonth.startOf("jMonth").unix(),
      }

      const isExist = months.find((item) => item.name === monthOBJ.name)

      if (!isExist) {
        months.push(monthOBJ)
      }
    }

    setProjectMonths(months)
  }, [])

  const canAddKPI =
    capabilities.includes("pes_add_project_kpi") &&
    !item.kpi_date &&
    !props.isMe
  const canEditKPI =
    capabilities.includes("pes_edit_project_kpi") &&
    item.kpi_date &&
    !props.isMe

  // const isCompletePaid = +item.cost - +item.paid === 0
  const isCompletePaid = item.isPaid

  return (
    <View
      style={{
        width: "100%",
        backgroundColor: color,
        borderRadius: 15,
        marginVertical: 5,
        paddingVertical: 7,
        direction: "ltr",
        display: "flex",

        zIndex: (props.item.isChange ? 500 : 1000) - props.item.index,
      }}
    >
      <View style={{ width: "100%", flexDirection: "row-reverse" }}>
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            gap: 10,
          }}
        >
          {isCompletePaid && (
            <View
              style={{
                width: 10,
                height: 10,
                backgroundColor: "#4CAF50",
                borderRadius: 1000,
              }}
            />
          )}

          <Text
            style={{
              transform: [{ rotate: "-90deg" }],
              fontFamily: "IranSans-Medium",
              fontSize: 12,
              color: color === "#F2F2F2" ? "#000" : "#fff",
            }}
          >
            #{item.id}
          </Text>
        </View>

        <View
          style={{ flex: 6, justifyContent: "center", alignItems: "flex-end" }}
        >
          <Text
            style={{
              color: color === "#F2F2F2" ? "#000" : "#fff",
              fontFamily: "Iransans-Medium",
              fontSize: 16,
              marginVertical: 5,
            }}
          >
            {item.customer_name}
          </Text>
          <Text
            style={{
              color: color === "#F2F2F2" ? "#000" : "#fff",
              fontFamily: "Iransans-Light",
              fontSize: 14,
              marginVertical: 5,
            }}
          >
            {item.package}
          </Text>
          {props.isSiteDepartment && (
            <Text
              style={{
                color: color === "#F2F2F2" ? "#000" : "#fff",
                fontFamily: "Iransans-Light",
                fontSize: 14,
                marginVertical: 5,
              }}
            >
              {item?.site || "سایت مشخص نیست"}
            </Text>
          )}
        </View>

        <View
          style={{
            flex: 2,
            paddingLeft: 15,
            justifyContent: "center",
            alignItems: "flex-start",
          }}
        >
          {props.hasFullAccess && (
            <View style={Styles(color).LeftSectionsContainer}>
              <Text style={Styles(color).date}>
                {item.price.toLocaleString()} تومان
              </Text>
            </View>
          )}

          <View style={Styles(color).LeftSectionsContainer}>
            <Text style={Styles(color).date}>
              تاریخ تحویل:{" "}
              {item.end_date != null
                ? moment.unix(item.end_date).format("jYYYY/jM/jD")
                : "بدون تایم"}
            </Text>
          </View>

          <View
            style={{
              marginTop: 10,
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              gap: 10,
            }}
          >
            <TouchableOpacity
              disabled={!canAddKPI && !canEditKPI}
              style={{
                backgroundColor: Colors.text,
                borderRadius: 5,
                justifyContent: "center",
                alignItems: "center",
                width: 100,
                padding: 5,
                position: "relative",
              }}
              onPress={(canAddKPI || canEditKPI) && dropDownToggle}
            >
              <Text style={{ ...Styles(color).date, ...{ color: "white" } }}>
                {item.kpi_date ? "حساب شده" : "حساب نشده"}
              </Text>

              {dropDown && (canAddKPI || canEditKPI) && (
                <ScrollView
                  showsVerticalScrollIndicator={false}
                  style={{
                    width: 100,
                    height: 200,
                    backgroundColor: Colors.text,
                    position: "absolute",
                    top: 15,
                    borderRadius: 5,
                  }}
                  contentContainerStyle={{
                    paddingHorizontal: 5,
                    paddingVertical: 10,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {projectMonths.map((item) => (
                    <TouchableOpacity
                      onPress={() => submit(item.unix)}
                      style={{ paddingVertical: 15 }}
                    >
                      <Text
                        style={{ ...Styles(color).date, ...{ color: "white" } }}
                      >
                        {item.name}
                      </Text>
                    </TouchableOpacity>
                  ))}
                </ScrollView>
              )}
            </TouchableOpacity>

            {props.isMe && (
              <>
                {item.danger ? (
                  <Ionicons name="warning" size={22} color="white" />
                ) : (
                  <View
                    style={{
                      backgroundColor: Colors.text,
                      borderRadius: 5,
                      justifyContent: "center",
                      alignItems: "center",
                      width: 30,
                      padding: 5,
                    }}
                  >
                    <Text
                      style={{ ...Styles(color).date, ...{ color: "white" } }}
                    >
                      {item.duration}
                    </Text>
                  </View>
                )}
              </>
            )}
          </View>
        </View>
      </View>
    </View>
  )
}

const Styles = (color) =>
  StyleSheet.create({
    dateTitle: {
      color: color === "#F2F2F2" ? "#000" : "#fff",
      fontFamily: "IranSans-Light",
      fontSize: 7,
    },
    LeftSectionsContainer: {
      width: "100%",
      flexDirection: "row-reverse",
      justifyContent: "flex-end",
      marginBottom: 5,
    },
    LeftSectionsContainer_staffs: {
      width: "100%",
      flexDirection: "row",
      justifyContent: "flex-start",
      marginBottom: 5,
    },
    date: {
      color: color === "#F2F2F2" ? "#000" : "#fff",
      fontFamily: "IranSans-Light",
      fontSize: 10,
    },
  })

export default AnalyseUserCard
